import { CrudManager } from "./crud";

const fields = [
  { key: "page", label: "Página (clave)", type: "text" },
  { key: "title", label: "Meta Title", type: "i18n" },
  { key: "description", label: "Meta Description", type: "i18n-textarea" },
  { key: "robots", label: "Robots", type: "select", options: ["index,follow", "noindex,follow", "noindex,nofollow"] },
  { key: "og_image", label: "Open Graph Image", type: "media" },
];

const columns = [
  { key: "page", label: "Página" },
  { key: "title", label: "Meta Title" },
  { key: "robots", label: "Robots" },
];

export default function SeoAdmin() {
  return (
    <div>
      <CrudManager coll="seo_pages" title="SEO Corporativo" fields={fields} columns={columns} testid="seo-admin" />
      <p className="font-mono-tech text-[10px] tracking-widest text-slate-400 mt-6">SITEMAP.XML AUTOMÁTICO: /api/sitemap.xml · ÁREA LEGAL = NOINDEX,FOLLOW POR DEFECTO</p>
    </div>
  );
}
